import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";



const CreatePassword = () => {


        const [showPassword, setShowPassword] = useState(false);
  
  
    return (
        <>
            <div className="commonHostMain">
                <div className="commonHostOuter">
                    <h2>Create Password</h2>
                    <div className="createPassowrdInner">
                        <div className="host_form">
                            <div className="mb-4">
                                <label htmlFor="password" className="form-label">
                                    Password<span className="required">*</span>
                                </label>
                                <div className="input-group">
                                    
                                    <Field
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    className='form-control'
                                    placeholder="Your password"
                                    />
                                    { <button
                                    type="button"
                                    className="btn btn-outline-secondary password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    > 
                                    <img
                                        src='/img/view-off.svg'
                                        alt="Logo"
                                        className="d-inline-block align-text-top"
                                        style={{ height: "40px" }}
                                        />
                                    </button> }
                                </div>
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="password" className="form-label">
                                    Confirm Password<span className="required">*</span>
                                </label>
                                <div className="input-group">
                                    
                                    <Field
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    className='form-control'
                                    placeholder="Confirm password"
                                    />
                                    { <button
                                    type="button"
                                    className="btn btn-outline-secondary password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    > 
                                    <img
                                        src='/img/view-off.svg'
                                        alt="Logo"
                                        className="d-inline-block align-text-top"
                                        style={{ height: "40px" }}
                                        />
                                    </button> }
                                </div>
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="invalid-feedback"
                                />
                            </div>
                            <div className="errorMessage">
                                <h4>Your password must contains</h4>
                                <ul>
                                    <li>
                                        <img width="14px" height="14px" src="/img/check_green.svg" alt="check"/>
                                        <span>At least 8 characters</span>
                                    </li>
                                    <li>
                                        <img width="14px" height="14px" src="/img/check_green.svg" alt="check"/>
                                        <span>At least 3 of the followings:</span>
                                    </li>
                                    <li>
                                        <img width="14px" height="14px" src="/img/check_green.svg" alt="check"/>
                                        <span>Lower case letters (a-z)</span>
                                    </li>
                                    <li>
                                        <img width="14px" height="14px" src="/img/check_green.svg" alt="check"/>
                                        <span>Upper case letters (A-Z)</span>
                                    </li>
                                    <li>
                                        <img width="14px" height="14px" src="/img/cross_red.svg" alt="cross"/>
                                        <span>Numbers (0-9)</span>
                                    </li>
                                    <li>
                                        <img width="14px" height="14px" src="/img/cross_red.svg" alt="cross"/>
                                        <span>Special characters (e.g. !@#$%^&*)</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreatePassword